/**
 * @module constants
 */

/**
 * @constant
 * A prefix for action anchor
 */

export const ACTION_ANCHOR_PREFIX = 'action:';

/**
 * @constant
 * A name for compact card style
 */

export const COMPACT_MESSAGE_CARD_STYLE = 'compact';

/**
 * @constant
 * An Id for the element in which the card is rendered
 */

export const CARD_ELEMENT_ID_PREFIX = 'amCardContent';

/**
 * @constant
 * A default max width for the container element in the card
 */

export const CARD_CONTAINER_DEFAULT_MAX_WIDTH = '640px';

/**
 * @constant
 * A default alignment for the container element in the card
 */
export const CARD_CONTAINER_DEFAULT_ALIGNMENT = 'left';

/**
 * @constant
 * Event name for logging telemetry when show/action card expanded
 */

export const ACTION_CARD_EXPANDED = 'ActionCardExpanded';

/**
 * @constant
 * Event name for logging telemetry when show/action card collapsed
 */

export const ACTION_CARD_COLLAPSED = 'ActionCardCollapsed';

/**
 * @constant
 * Event name for logging telemetry when card is rendered
 */

export const MESSAGE_CARD_RENDERED = 'MessageCardRendered';

/**
 * @constant
 * Event name for logging telemetry when card is hidden as a response from the server
 */

export const MESSAGE_CARD_HIDDEN = 'MessageCardHidden';

/**
 * @constant
 * Event name for logging telemetry when card is removed as a response from the server
 */

export const MESSAGE_CARD_REMOVED = 'MessageCardRemoved';

/**
 * @constant
 * Event name for logging telemetry when open url action is clicked
 */

export const MESSAGE_CARD_VIEW_ACTION_CLICKED = 'MessageCardViewActionClicked';

/**
 * @constant
 * Event name for logging telemetry when toggle visibility action is clicked
 */

export const TOGGLE_VISIBILITY_ACTION_CLICKED = 'ToggleVisibilityActionClick';

/**
 * @constant
 * Event name for logging telemetry when http action got executed
 */
export const HTTP_POST_ACTION_EXECUTED = 'HttpPostActionExecuted';

/**
 * @constant
 * A key to access the action context from the Action object
 */

export const ACTION_CONTEXT = 'actionContext';

/**
 * @constant
 * An enum representing the list of http status codes
 */

export const enum HttpStatusCode {
    Unauthorized = '401',
    Forbidden = '403',
}

/**
 * @constant
 * An enum representing the list of http status codes
 */

export const AUTHENTICATION_FLOW_CLIENT_TYPE = 'webviewbasedamclients';

/**
 * @constant
 * Amount of time wait before closing the Authentication window
 */

export const AUTHENTICATION_WINDOW_CHECK_TIMEOUT = 10 * 60 * 1000;

/**
 * @constant
 * Amount of time to wait before checking whether the Authentication window is closed or not
 */

export const AUTHENTICATION_WINDOW_CHECK_CLOSED_INTERVAL = 1 * 1000;

/**
 * @constant
 * A member to hold the auto dismiss timeout for a snack bar in milliseconds
 */

export const DEFAULT_ACTION_RESPONSE_SNACKBAR_TIMEOUT = 8 * 1000;
